import { render } from "./SelectCateg.vue?vue&type=template&id=7d2ea717&scoped=true"
import script from "./SelectCateg.vue?vue&type=script&lang=js"
export * from "./SelectCateg.vue?vue&type=script&lang=js"

import "./SelectCateg.vue?vue&type=style&index=0&id=7d2ea717&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2ea717"]])

export default __exports__